import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Image } from 'semantic-ui-react';
import { RootConsumer } from '../RootComponent';
import styles from './Playlist.scss';

const PlaylistArtwork = ({ playlist }) => (
  <RootConsumer>
    {({ isMobile }) => (
      <div
        className={
          isMobile
            ? styles.playlistThumbnailMobile
            : styles.playlistThumbnail
        }
      >
        {!playlist.thumbnail && <Icon name='music' />}
        {playlist.thumbnail && <Image src={playlist.thumbnail.url} />}
      </div>
    )}
  </RootConsumer>
);

PlaylistArtwork.propTypes = {
  playlist: PropTypes.object.isRequired
};

export default PlaylistArtwork;



// WEBPACK FOOTER //
// ./webpack/components/Playlist/Artwork.js